module.exports = __webpack_public_path__ + "static/media/avatar2.324d1a8a.png";